var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _ellipse2, _path32, _g, _path33, _path34, _g2, _g3, _g4, _path35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 179,
    viewBox: "0 0 320 179",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.752 18.532)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 72.388,
    cy: 72.331,
    rx: 72.388,
    ry: 72.331
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.363 130.936a2.885 2.885 0 0 1 2.43 3.276 2.887 2.887 0 0 1-5.709-.848 2.886 2.886 0 0 1 3.279-2.428m.424-2.853a5.81 5.81 0 0 0-1.16-.054l-.131.883a4.83 4.83 0 0 0-1.467.365l-.532-.717c-.351.165-.681.37-.992.6-.31.23-.604.486-.863.774l.531.716c-.32.386-.582.82-.776 1.298l-.882-.131a5.718 5.718 0 0 0-.34 2.282l.883.13c.046.514.17 1.006.365 1.468l-.716.531c.164.351.37.68.6.99.23.311.486.604.774.863l.718-.531c.384.322.82.583 1.297.776l-.13.882a5.766 5.766 0 0 0 2.283.34l.131-.883a4.846 4.846 0 0 0 1.468-.366l.533.717c.351-.164.681-.37.99-.6.312-.23.604-.485.864-.773l-.532-.718c.323-.384.582-.819.776-1.296l.884.13a5.715 5.715 0 0 0 .34-2.282l-.884-.131a4.816 4.816 0 0 0-.366-1.466l.718-.531a5.803 5.803 0 0 0-.6-.992 5.755 5.755 0 0 0-.775-.862l-.717.531a4.845 4.845 0 0 0-1.299-.775l.131-.883a5.804 5.804 0 0 0-1.124-.285",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.325 12.122a3.355 3.355 0 0 1 2.827 3.81 3.355 3.355 0 0 1-6.64-.986 3.357 3.357 0 0 1 3.813-2.824m.493-3.319a6.758 6.758 0 0 0-1.348-.062l-.153 1.027a5.618 5.618 0 0 0-1.706.424l-.619-.834c-.408.192-.792.43-1.154.698-.36.268-.702.565-1.003.9l.618.834a5.672 5.672 0 0 0-.903 1.509l-1.026-.153a6.65 6.65 0 0 0-.395 2.654l1.026.153c.054.597.198 1.169.425 1.706l-.833.618c.19.409.43.791.697 1.152.27.361.566.702.902 1.003l.835-.618a5.62 5.62 0 0 0 1.508.903l-.152 1.026a6.706 6.706 0 0 0 2.656.394l.153-1.026a5.637 5.637 0 0 0 1.707-.425l.62.834c.408-.191.792-.43 1.152-.698a6.736 6.736 0 0 0 1.004-.9l-.62-.834c.377-.447.679-.953.904-1.508l1.028.152a6.647 6.647 0 0 0 .394-2.654l-1.027-.153a5.602 5.602 0 0 0-.425-1.706l.835-.617a6.75 6.75 0 0 0-.7-1.153c-.266-.361-.563-.701-.899-1.003l-.835.618a5.636 5.636 0 0 0-1.51-.902l.152-1.027a6.75 6.75 0 0 0-1.308-.332",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.552 71.154A3.854 3.854 0 0 1 5.721 64.6a3.861 3.861 0 0 1 6.615 2.7c0 2.1-1.682 3.814-3.784 3.855zm0-5.708a1.828 1.828 0 1 0-.001 3.656 1.828 1.828 0 0 0 .001-3.656z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "nonzero",
    d: "M42.713 125.732h2.309v6.921h-2.309z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M81.443 8.266h2.309v9.228h-2.309z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "nonzero",
    d: "M40.404 128.039h6.926v2.307h-6.926z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M77.98 11.726h9.235v2.307H77.98z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    fillRule: "nonzero",
    d: "M146.325 22.786h2.309v11.535h-2.309z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    fillRule: "nonzero",
    d: "M141.707 27.4h11.544v2.307h-11.544z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m28.846 124.79 34.756-15.475-13.67-89.432-34.77 15.475z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m63.602 109.315-34.756 15.474-13.683-89.431 34.769-15.475z",
    opacity: 0.1,
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    fillRule: "nonzero",
    d: "m101.41 113.713-37.808-4.398-13.67-89.432 37.795 4.398z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m136.166 98.226-34.756 15.487L87.727 24.28l34.769-15.474z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E1E1",
    fillRule: "nonzero",
    d: "M50.726 25.113 21.758 38.017l12.082 78.96 28.968-12.904 37.795 4.398 28.968-12.892-12.069-78.96-28.968 12.892z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m60.626 86.992 7.478 1.172-.176 1.12-7.344-1.15-6.662 2.395-.353-1.077 6.792-2.438zM43.455 28.144l16.066 9.78-.59.968-16.067-9.779zM69.864 32.741l20.782 8.535 9.56.917v.744l8.435 55.123 6.195 4.069-1.78.818-5.913-3.926-8.46-55.342-8.31-.796-.231-.057-20.897-8.581z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m72.696 27.645 1.705.201-3.723 6.21-1.389-.848zM92.233 27.846l14.25 5.93-.436 1.047-15.23-6.38zM127.52 82.128l.167 1.121-21.83 3.264-.167-1.122z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m69.878 32.794.69 1.473-33.555 15.677-14.588-5.06.533-1.536 13.964 4.843zM48.028 82.524l2.458-.082.328 9.847-10.479 10.617-9.03 3.162-.813-2.32 8.493-2.973 9.335-9.46zM88.11 40.626l1 1.283-6.627 5.158-1.113.889-.917.72c-.52.403-.91.693-1.165.86a20.321 20.321 0 0 1-6.294 2.299l-.605.103-5.828.892.348 3.621c.056.554.102.985.135 1.267l.036.278.119.794-10.961 1.767-10.69 3.757-.54-1.534L55.766 59l.14-.036 9.47-1.527-.218-2.171-.354-3.81 7.337-1.124a18.664 18.664 0 0 0 6.298-2.182l.172-.12c.138-.1.322-.237.544-.407l1.204-.941 1.27-1.015 6.481-5.04z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m74.47 50 7.176 21.927-1.08.352-7.175-21.926z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.362,
    d: "m55.354 59.918-9.458-15.097M88.976 71.776l.958 12.06-6.986.919"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m61.27 47.033.376 1.07L49.943 52.2l-.375-1.07z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m60.108 43.836 1.538 4.268-1.083.385-1.545-4.266zM114.673 17.872l-3.23 15.554 3.354 21.943-13.188 2.013-.246-1.607 11.58-1.767-3.153-20.629 2.762-14.598zM57.103 70.597l.661 2.43-31.209 8.477-.661-2.43zM49.76 82.787l.21 9.25-1.716.039-.21-9.25zM36.608 48.974l2.26-.97 3.746 8.717-14.81 5.213-.204.052-3.412.573.742 6.4-2.443.282-1.01-8.718 5.608-.944 12.23-4.304zM123.384 83.389l2.292 13.929-1.039.454-2.373-14.196z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M106.505 92.165 98.41 95.1l-22.952 1.02"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m48.145 82.53 10.67-4.416 16.704.694.234 26.669-1.627.014-.221-25.124-14.8-.615-10.338 4.28z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m66.654 88.196 1.135-.002.013 11.232-7.75.67-.196 5.698-1.134-.04.232-6.702 7.712-.666zM124.302 61.212l.196 1.117-21.552 3.768-.196-1.118zM128.883 90.884l.14 1.125-.683.088c-.513.068-1.026.14-1.504.211l-.824.13-.576.103a8.501 8.501 0 0 0-.406.087l-.164.046-.376-1.07c.211-.074.579-.154 1.101-.245l.233-.04c.256-.042.539-.087.844-.133l1.005-.143 1.21-.16zM119.841 31.433l.156 1.308-14.02 2.093-.18-1.12z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m102.483 65.443.906 1.35-8.17 5.477-26.17.358-.811 13.066c-.123 1.822-.188 2.532-.25 2.775l-.023.069-1.487-.66.63-10.113.406-6.741 27.2-.374 7.769-5.207z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "m74.498 80.218-6.381.013-.303 8.997.101 5.558.126 4.637-7.894.643-.177 5.267 2.838-1.298 11.198 1.298z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCCCC",
    fillRule: "nonzero",
    d: "m105.978 34.834-2.897-1.275-3.667 2.165 2.712 19.877 10.817-1.593-3.063-19.706z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1) rotate(19 -60.072 -281.214)",
    d: "m28.478 100.447 34.288-16.51-14.19-78.63L14.184 21.86z",
    opacity: 0.21,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#BBB",
    fillRule: "nonzero"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "nonzero",
    d: "M122.496 8.807h1.06l13.342 88.965-.732.454z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "m63.602 109.315 37.808 4.398 35.488-15.94.386 2.072-35.548 15.501-35.59-3.536-36.657 14.038-.643-1.059z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.772 125.76a.227.227 0 0 1-.113 0H102.772z",
    fill: "#231F20",
    fillRule: "nonzero",
    opacity: 0.06
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF1B12",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m132.32 92.51 8.304-2.33h9.838l25.708-.489 7.44-4.824"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.238,
    cy: 2.236,
    rx: 2.238,
    ry: 2.236,
    transform: "translate(194.458 14.883)",
    fill: "#FFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M160.565 146.8c34.637 5.786 53.164 8.844 55.58 9.174 3.626.496 5.477-3.12 3.581-4.786-.552-.485-3.328-.485-8.327 0l-47.177-7.37-8.743-.894a.8.8 0 0 0-.396 1.531l5.482 2.344z",
    fill: "#DCDBDB",
    opacity: 0.736
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160.81 136.28-10.956 1.692a.336.336 0 0 0-.045.637l9.741 5.33 1.26-7.66z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.759 138.606a.336.336 0 0 1 .044-.637l2.147-.322 1.47-.204c-.438.543-.872 1.302-.642 2.67l.072.174-3.091-1.681z",
    fill: "#ED2124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.273 151.76-1.015-.188-1.217-.203-42.474-7.429a5.038 5.038 0 0 1-.957-3.435 5.039 5.039 0 0 1 2.23-4.173l42.075 7.367 2.332.399c-1.516-.258-2.645 7.445-.974 7.662z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.244 152.089-2.215-.391c-.654-.046-.835-1.557-.687-3.18.152-2.18.897-4.637 1.766-4.526l1.664.302.604.042c-.872-.061-1.597 2.347-1.782 4.507-.11 1.576.045 2.984.638 3.177l.012.069z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.694 152c-1.518-.224-.441-7.914 1.078-7.706l2.265.394c-1.536-.209-2.613 7.48-1.077 7.689l-2.266-.377z",
    fill: "#4A4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.087 152.812-2.231-.392c-1.503-.206-.528-7.633.944-7.715l2.247.41c-1.484-.239-2.476 7.44-.96 7.697z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.098 145.101c-.654-.045-1.28 1.19-1.676 2.763-.535 2.102-.648 4.688.199 4.865l9.121 1.413c2.105.517 3.326-7.524 1.246-7.736l-8.89-1.305z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.33 146.31c-1.49 1.066-2.184 5.969-1.232 7.751l.644.08c2.105.518 3.326-7.523 1.246-7.735l-.659-.096z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.654 149.637c-.818 1.258-1.948 1.051-1.948 1.051-.117 1.331-.007 2.626.392 3.373l.644.08c2.105.518 3.326-7.523 1.246-7.735.323 1.316.212 2.393-.334 3.231z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.721 152.74 8.377 1.321c-.37-.347-.5-2.187-.37-3.43l-59.26-10.018-8.818-2.133 9.43 5.19.584.327.1.008 49.957 8.734z",
    fill: "#231F20",
    opacity: 0.191
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E5E5",
    d: "m207.25 35.164 5.027-1.857 9.409 83.38-2.036 1.455z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m179.485 75.3 3.54-5.546 5.49 3.626-1.24 1.941-2.196-1.45.996 4.68-2.258.48-.996-4.68-1.415 2.218-1.921-1.27z",
    fill: "#7A7E80"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#7A7E80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m194.455 77.292 5.418 3.732-3.815 5.36-1.896-1.306 1.525-2.145-4.712.832-.4-2.273 4.712-.832-2.167-1.492 1.335-1.876z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#7A7E80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m192.266 93.388-3.54 5.545-5.49-3.626 1.239-1.94 2.196 1.45-.995-4.68 2.257-.48.996 4.68 1.415-2.218 1.922 1.27z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#DF1B12",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.366 86.334-.065-1.848-1.583.055-.26-7.458-1.53.053-3.283 1.393c.591 1.313.715 1.58.738 1.628l.004.01 1.947-.814.184 5.265-2.147.075.064 1.848 5.931-.207zm4.432-.048c2.307-.08 3.26-1.645 3.191-3.626l-.087-2.5c-.07-1.98-1.129-3.474-3.437-3.394-2.308.081-3.26 1.645-3.191 3.626l.087 2.5c.069 1.98 1.129 3.475 3.437 3.394zm-.07-1.994c-.859.03-1.124-.627-1.157-1.597l-.08-2.26c-.034-.984.185-1.644 1.044-1.674.859-.03 1.123.613 1.157 1.597l.08 2.26c.033.97-.185 1.644-1.044 1.674zm8.067 1.715c2.307-.08 3.26-1.645 3.191-3.626l-.087-2.5c-.07-1.98-1.129-3.474-3.437-3.394-2.308.08-3.26 1.645-3.191 3.626l.087 2.5c.069 1.98 1.129 3.474 3.437 3.394zm-.07-1.995c-.859.03-1.123-.626-1.157-1.597l-.08-2.26c-.034-.984.185-1.643 1.044-1.673.859-.03 1.123.613 1.157 1.596l.08 2.26c.033.971-.185 1.644-1.044 1.674zm10.924 1.818 2.936-10.193-1.892.066-2.936 10.193 1.892-.066zm-3.07-4.446c1.328-.046 2.109-.765 2.062-2.108l-.04-1.17c-.048-1.343-.877-2.02-2.206-1.973-1.328.046-2.149.78-2.102 2.123l.04 1.17c.047 1.33.917 2.005 2.246 1.958zm-.054-1.542c-.201.007-.407-.119-.416-.371l-.05-1.41c-.008-.252.188-.392.39-.4.188-.006.393.12.402.373l.05 1.409c.008.253-.188.393-.376.4zm7.448 5.557c1.329-.046 2.11-.766 2.063-2.108l-.041-1.17c-.047-1.343-.877-2.02-2.205-1.973-1.328.046-2.15.78-2.102 2.123l.04 1.17c.047 1.33.917 2.005 2.245 1.958zm-.054-1.542c-.2.007-.407-.119-.416-.372l-.049-1.409c-.009-.252.188-.392.39-.4.187-.006.393.12.402.372l.05 1.41c.008.252-.189.392-.377.399z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m120.668 88.91 7.726 4.561-4.68 7.654-2.704-1.596 1.871-3.062-6.33 1.579-.762-3.054 6.33-1.579-3.089-1.824 1.638-2.679z",
    fill: "#7A7E80"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.345053d2276b2132cdf66f8bb1db261f.svg";
export { ForwardRef as ReactComponent };